import withPortal from './withPortal';

export default withPortal;
